module.exports = __webpack_public_path__ + "static/media/ourExclusive.b587d9a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/other/ourExclusive.svg
// module id = 870
// module chunks = 0